export default __webpack_public_path__ + "static/media/back_btn.019b6a5b.svg";